import React, {Component} from 'react';
import classnames from 'classnames';
import {MoreContainer} from './style';
import {assetTargetAuctionStatus} from '../../../utils/status'
import {BUSINESS_INFO, objDeepCopy} from '../../../utils/tool'
import unit_institution from "../../../store/asset_institution/unit_institution";
import {observer} from 'mobx-react';

@observer
class MoreItem extends Component {
  constructor(props) {
    super(props);
    const {MoreItem} = this.props.store;
    if (MoreItem) {
      this.state = MoreItem
    } else {
      this.state = {
        items: objDeepCopy(assetTargetAuctionStatus),
      }
    }
  }

  componentDidMount() {
  }

  handleClick = (item) => {
    let curItem = {};
    const {items} = this.state;
    items.forEach((value, index) => {
      value.selected = false;
      if (index === item.index) {
        value.selected = true;
        curItem = value;
      }
    })
    this.setState({
      items,
    });

    // 暂存数据
    const {saveCurrData, addCondition} = this.props.store;

    const {closeFilter, defaultIndex, changeCurrFilterItems} = this.props;
    saveCurrData('MoreItem', this.state);
    // 增加选择条件
    const {publishSource} = unit_institution;
    if(publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
      addCondition(curItem.conditionHaiGuan, true);
    }else{
      addCondition(curItem.condition, true);
    }
    closeFilter();
    changeCurrFilterItems(defaultIndex, item.name);
  }

  render() {
    const {items} = this.state;
    return (
      <MoreContainer>
        <div className={'title-card'}>
          <div className="content">
            {
              items && items.length && items.map((item, index) => {
                return (
                  <div
                    key={item.name}
                    className={classnames(["filter-item", {
                      'actived': item.selected,
                    }])}
                    onClick={() => {
                      this.handleClick({index, id: item.param, name: item.name,})
                    }}
                  >{item.name}</div>
                )
              })
            }
          </div>
        </div>
      </MoreContainer>
    );
  }
}

export default MoreItem;
